import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirpodCase: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAirpodCase"><Path d="M7.5 3C5.01472 3 3 5.01472 3 7.5V9H21V7.5C21 5.01472 18.9853 3 16.5 3H7.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 16.5V11H21V16.5C21 18.9853 18.9853 21 16.5 21H7.5C5.01472 21 3 18.9853 3 16.5ZM12.0005 15.5C11.3101 15.5 10.7505 14.9404 10.7505 14.25C10.7505 13.5596 11.3101 13 12.0005 13C12.6908 13 13.2505 13.5596 13.2505 14.25C13.2505 14.9404 12.6908 15.5 12.0005 15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAirpodCase;
